import React, { FC } from 'react';
import css from './TemplatesMainPage.scss';
import { MainPageSideBar } from './SubComponents/MainPageSideBar';
import { HeadingSection } from './SubComponents/PageHeader/HeadingSection';
import { TemplatesGrid } from '../CommonComponents/TemplatesGrid/TemplatesGrid';
import { useTemplatesData } from '../../hooks/useTemplatesData';
import { TemplatesGridHeading } from './SubComponents/TemplatesGridHeading';
import { usePageNavigate } from '../../hooks/usePageNavigate';
import { useTabs } from '../../hooks/useTabs';
import { AppLoader } from '../App/AppLoader';
import { DataHooks } from '../../constants/dataHooks';
import { filterToUrlParamMapper } from '../../utils/urlParams-utils';
import { useTemplatesPageBi } from '../../hooks/useTemplatesPageBi';

export const TemplatesMainPage: FC = () => {
  const { templates, appLoaded } = useTemplatesData();
  const { navigateToTemplate } = usePageNavigate();
  const { shouldDisplayTemplateByTab, activeTabId } = useTabs();
  const filteredTemplatesByTab = templates.filter(shouldDisplayTemplateByTab);
  const { reportClickOnTemplate } = useTemplatesPageBi();
  const mainGridRef = React.useRef<HTMLDivElement>(null);
  const originTab = filterToUrlParamMapper?.[activeTabId];

  if (!appLoaded) {
    return <AppLoader />;
  }

  return (
    <div data-hook={DataHooks.MainPage}>
      <HeadingSection />
      <div className={css.gridAndSideBarWrapper}>
        <MainPageSideBar mainGridRef={mainGridRef} />
        <div ref={mainGridRef} className={css.mainGridLayout}>
          <TemplatesGridHeading />
          <TemplatesGrid
            templates={filteredTemplatesByTab}
            onTemplateClick={(template) => {
              reportClickOnTemplate(template.id);
              navigateToTemplate(template, originTab);
            }}
          />
        </div>
      </div>
    </div>
  );
};
